<template>
  <div class="policyArea" @click="onAreaClick">
    <h1>{{ t('common-cookie-policy') }}</h1>
    <p v-if="policy?.date" class="date">{{ policy.date }}</p>
    <header
      v-if="policy?.headerHtml"
      class="markdownBody policyHeaderArea"
      v-html="policy.headerHtml"
    />
    <div
      v-for="(intro, idx) in policy?.introSections ?? []"
      :key="`intro-${idx}`"
      class="policyItem markdownBody"
      v-html="intro"
    />
    <div
      v-for="(article, idx) in policy?.articles ?? []"
      :id="`Article${idx + 1}`"
      :key="`article-${idx}`"
      class="policyItem"
    >
      <div class="policyInfo" :class="{ on: openFlags[idx] }">
        <div class="titleArea" @click.stop="toggle(idx)">
          <h2>{{ article.title }}</h2>
          <div class="toggleBtn" />
        </div>
        <div class="infoArea markdownBody" v-html="article.html" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDialogStore } from "~~/application/store/dialog/dialogStore";
import DialogType from "~~/application/components/Common/Dialog/model/DialogType";

const { t } = useI18n();
const dialogStore = useDialogStore();
const { policy } = usePolicyMarkdown('cookie');
const openFlags = ref<boolean[]>([]);

watchEffect(() => {
  openFlags.value = (policy.value?.articles ?? []).map(() => true);
});

const toggle = (idx: number) => {
  openFlags.value[idx] = !openFlags.value[idx];
};

const onAreaClick = (event: MouseEvent) => {
  const target = (event.target as HTMLElement | null)?.closest?.('[data-action="cookie-preferences"]');
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  dialogStore.open({
    type: DialogType.CookieAccept,
    props: {
      isShowCookiePreference: true,
    },
  });
};
</script>
